import { c as _c } from "react/compiler-runtime";
import type { ReactElement } from 'react';
import { Image } from '@/app/components/media/image';
import { getImageAlt, isPortraitImage, isSameRatioImages } from '@/app/lcv/components/sections/news-activities/details/content-rows/utils';
import { DetailsContentRow } from '@/app/lcv/components/sections/news-activities/details/details-content-row';
import { type ImageGalleryContentProps } from '@/app/lcv/components/sections/news-activities/types';
import { cn } from '@/app/utils/cn';
import type { UploadFile } from '@/types/tis-cms/types';
import { Enum_Componentnewsimages_Imagedisplay } from '@/types/tis-cms/types';
export const ImagesGalleryContent = t0 => {
  const $ = _c(7);
  const {
    data,
    title,
    index,
    testId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== data.imageDisplay || $[1] !== data.images || $[2] !== index || $[3] !== testId || $[4] !== title) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const images = (data.images ?? []).filter(_temp);
      if (images.length === 0) {
        t2 = null;
        break bb0;
      }
      const cmsTwoColumn = data.imageDisplay === Enum_Componentnewsimages_Imagedisplay.TwoColumn;
      const chunkedRows = [];
      let i = 0;
      while (i < images.length) {
        const current = images[i];
        const isPortrait = isPortraitImage(current);
        const next = images[i + 1];
        if (!current) {
          i = i + 1;
          i;
          continue;
        }
        const canDisplayTwoColumn = next !== undefined && isSameRatioImages(current, next) && cmsTwoColumn;
        if (canDisplayTwoColumn) {
          chunkedRows.push(<DetailsContentRow key={`${testId}-pair-${i}`} contentClassName="grid grid-cols-1 gap-4 lg:grid-cols-2">{[current, next].map((image, imageIndex) => <figure key={`${testId}-image-${i + imageIndex + 1}`} className="aspect-3-2 rounded-base-md relative block w-full overflow-hidden"><Image src={image.url} alt={getImageAlt(image, title)} width={image.width ?? 640} height={image.height ?? 360} layout="fill" aspectRatio="aspect-3-2" sizes="(min-width: 1024px) 680px, 90vw" /></figure>)}</DetailsContentRow>);
          i = i + 2;
          i;
          continue;
        }
        chunkedRows.push(<DetailsContentRow key={`news-image-${index}-${i}`} contentClassName={cn({
          "col-span-12 col-start-1 md:col-span-8 md:col-start-3 xl:col-span-6 xl:col-start-4": isPortrait
        })}><figure className={cn("rounded-base-md relative block w-full overflow-hidden", {
            "aspect-2-3": isPortrait
          })}><Image src={current.url} alt={getImageAlt(current, title)} width={current.width ?? 640} height={current.height ?? 360} layout={isPortrait ? "fill" : "ratio"} aspectRatio={isPortrait ? "aspect-2-3" : "calculate"} sizes="(min-width: 1024px) 680px, 90vw" /></figure></DetailsContentRow>);
        i = i + 1;
        i;
      }
      t1 = <>{chunkedRows}</>;
    }
    $[0] = data.imageDisplay;
    $[1] = data.images;
    $[2] = index;
    $[3] = testId;
    $[4] = title;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
function _temp(img) {
  return Boolean(img?.url);
}